import { render, staticRenderFns } from "./FailureByBaseHelp.vue?vue&type=template&id=458a8a20&"
import script from "./FailureByBaseHelp.vue?vue&type=script&lang=js&"
export * from "./FailureByBaseHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports